import { useTranslation } from "react-i18next"
import { FieldArray, Field, useFormikContext } from "formik"
import { Stack, Button, IconButton, Grid2 as Grid, Typography } from "@mui/material"
import { Add, Delete } from "@mui/icons-material"
import { FormikTextField } from "./formsHelpers"

export function TcInOutField({ name, label }: { name: string; label: string }) {
  const { t } = useTranslation()
  const { values } = useFormikContext<any>()

  return (
    <div>
      {label && (
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          {label}
        </Typography>
      )}
      <FieldArray name={name}>
        {({ remove, push }) => (
          <div>
            {values[name] &&
              values[name].length > 0 &&
              values[name].map((_item: string[], index: number) => (
                <>
                  <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                    <Grid container spacing={2} flexGrow={1}>
                      <Grid size={4}>
                        <Field
                          label="TCIN"
                          name={`${name}[${index}].tcin`}
                          placeholder="tcin"
                          component={FormikTextField}
                          margin="dense"
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid size={4}>
                        <Field
                          label="TCOUT"
                          name={`${name}[${index}].tcout`}
                          placeholder="tcout"
                          component={FormikTextField}
                          margin="dense"
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid size={1}>
                        <IconButton
                          title="Elimina allegato"
                          sx={{ mt: 1 }}
                          color="error"
                          type="button"
                          onClick={() => {
                            remove(index)
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Stack>
                </>
              ))}

            <Button
              variant="contained"
              type="button"
              size="small"
              onClick={() => push({ tcin: "", tcout: "" })}
              sx={{  mb: 1 }}
            >
              <Add sx={{ mr: 1 }} />
              {t("general.aggiungi_riga")}
            </Button>
          </div>
        )}
      </FieldArray>
    </div>
  )
}
